import { useMemo, Children } from "react";
import CollectionFilter from "./CollectionFilter";
import { ALL_PRODUCTS_OBJECT } from "./Home/CollectionHome";

const StoreCollections = ({ collections, setFilter, selectedCollection }) => {
  const storeCollections = useMemo(() => {
    const list = [];
    list.push(
      <CollectionFilter
        key={"initial"}
        collection={ALL_PRODUCTS_OBJECT}
        selectedCollection={selectedCollection}
        setFilter={setFilter}
      />,
    );
    const collectionList = Children.toArray(
      collections.map((collection) => (
        <CollectionFilter
          key={collection._id}
          collection={collection}
          selectedCollection={selectedCollection}
          setFilter={setFilter}
        />
      )),
    );

    return list.concat(collectionList);
  }, [collections, selectedCollection, setFilter]);
  return collections.length ? storeCollections : null;
};
export default StoreCollections;
